import {StyleSheet, PixelRatio} from 'react-native';
import {isIphoneX} from "../../../../common/utils";

export default StyleSheet.create({
    container: {
        flex: 1
    },

    selected: {
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: 11,
        height: 10,
        backgroundColor: '#00BCD4',
        borderTopLeftRadius: 5,
        borderBottomRightRadius: 4
    },
    searchText: {
        fontSize: 14,
        color: '#212121'
    },

    searchSubText: {
        fontSize: 12,
        color: '#333333',
        transform: [{scaleX: 0.83}, {scaleY: 0.83}],
        transformOrigin: 'top'
    },

    searchActiveText: {
        color: '#00cad8'
    },

    searchBaseItem: {
        width: '100%',
        height: '100%'
    },

    sepcText: {
        paddingTop: 6,
        paddingBottom: 2
    },

    searchItem: {
        minHeight: 36,
        flex: 1,
        backgroundColor: '#f7f8fa',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 4
    },

    searchActiveItem: {
        backgroundColor: '#e6fafc',
    },

    searchDisableItem: {
        backgroundColor: '#fafafa'
    },

    searchDisableText: {
        color: '#e6e6e6'
    },

    searchFilterBlock: {
        paddingTop: 13,
        paddingHorizontal: 17,
    },

    searchFilterBlockTitle: {
        fontSize: 16,
        textAlign: 'left',
        fontWeight: "500",
        color: '#333',
        marginTop: 20
    },

    searchMonthBlock: {
        flexDirection: 'row',
        marginTop: 12,

    },

    searchMonth: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: 10,
        backgroundColor: '#f7f8fa',
        minHeight: 36,
        borderRadius: 4,
        overflow: 'hidden'
    },

    searchWeekContainer: {
        flexDirection: 'row',
        marginTop: 12,
    },

    searchWeek: {
        marginRight: 2
    },

    searchDay: {
        marginHorizontal: 24,
        marginTop: 10,
        height: 50,
        position: 'relative'
    },

    searchDayBar: {
        marginTop: 20,
        height: 4,
        backgroundColor: '#e0e0e0'
    },

    searchDayActiveBar: {
        height: 4,
        position: 'absolute',
        left: 0,
        width: '100%',
        borderRadius: 3,
        backgroundColor: '#00d4e3'
    },

    searchDayLeft: {
        position: 'absolute',
        left: -30,
        top: 0,
    },

    searchDayRight: {
        position: 'absolute',
        right: -30,
        top: 0,
    },

    searchDisable: {
        backgroundColor: '#e0e0e0',
    },

    checkIcon: {
        marginTop: -3,
        marginLeft: -2
    },

    searchDayDisableText: {
        color: '#e0e0e0',
        fontSize: 14
    },

    searchDayText: {
        fontSize: 14
    },

    searchBallLeft: {
        borderRadius: 24,
        borderTopRightRadius: 0,
        width: 30,
        height: 30,
        backgroundColor: '#00d4e3',
        marginTop: 8
    },

    searchBallRight: {
        borderRadius: 24,
        borderTopLeftRadius: 0,
        width: 30,
        height: 30,
        backgroundColor: '#00d4e3',
        marginTop: 8,
    },

    lineBlock: {
        height: 10,
        backgroundColor: '#f7f8fa',
        marginTop: 20
    },

    customFilterBlock: {
        marginHorizontal: 17,
        marginTop: 20,
        marginBottom: 30,
        flexDirection: 'row',
        justifyContent: 'space-between'
    },

    customTitle: {
        fontSize: 16,
        fontWeight: '500',
        color: '#333'
    },

    selectText: {
        color: '#999',
        fontSize: 14
    },

    selectActiveText: {
        color: '#00d4e3'
    },

    submitBtn: {
        backgroundColor: '#00d4e3',
        borderRadius: 22,
        marginHorizontal: 24,
        marginTop: 10,
        marginBottom: isIphoneX() ? 50 : 60,
        height: 44
    },
    submitBtnText: {
        lineHeight: 44,
        textAlign: 'center',
        color: '#fff',
        fontSize: 18,
        fontWeight: '500'

    }
});